import React, { useState, useEffect } from 'react';
import { ThemeContext } from './ThemeContext.js';
import { setCurrentLanguage } from '../i18n';

const DEFAULT_LANGUAGE = 'zh-CN';

export const ThemeProvider = ({ children }) => {
    // 主题状态
    const [theme, setTheme] = useState(() => {
        const savedTheme = localStorage.getItem('theme');
        return savedTheme || 'light';
    });

    // 语言固定为中文（中英文切换入口已隐藏）
    const [language, setLanguage] = useState(DEFAULT_LANGUAGE);

    // 导航布局：sidebar 左侧竖栏 | horizontal 顶部横栏
    const [navLayout, setNavLayout] = useState(() => {
        const saved = localStorage.getItem('navLayout');
        return saved === 'sidebar' ? 'sidebar' : 'horizontal';
    });

    // 应用主题
    useEffect(() => {
        const root = window.document.documentElement;
        root.classList.remove('light', 'dark');
        root.classList.add(theme);
        localStorage.setItem('theme', theme);
    }, [theme]);

    // 强制中文，覆盖历史 localStorage 中的英文偏好
    useEffect(() => {
        localStorage.setItem('language', DEFAULT_LANGUAGE);
        setCurrentLanguage(DEFAULT_LANGUAGE);
        if (language !== DEFAULT_LANGUAGE) {
            setLanguage(DEFAULT_LANGUAGE);
        }
    }, [language]);

    // 保存导航布局
    useEffect(() => {
        localStorage.setItem('navLayout', navLayout);
    }, [navLayout]);

    // 切换主题
    const toggleTheme = () => {
        setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
    };

    // 语言切换已停用，保持中文
    const toggleLanguage = () => {};

    const toggleNavLayout = () => {
        setNavLayout(prev => prev === 'sidebar' ? 'horizontal' : 'sidebar');
    };

    const value = {
        theme,
        language,
        navLayout,
        toggleTheme,
        toggleLanguage,
        toggleNavLayout,
        setTheme,
        setLanguage,
        setNavLayout
    };

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};
